export const authConstants = {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',

  LOGOUT: 'LOGOUT',

  WHO_AM_I_LOADED: 'WHO_AM_I_LOADED',

  SET_CHANNEL: 'SET_CHANNEL'
};



// WEBPACK FOOTER //
// ./src/_constants/authentication.constants.js